export const MOCK_DATABASE = [
  {
    id: 1,
    title: "Airmax",
    images: [
      "https://fgl.scene7.com/is/image/FGLSportsLtd/FGL_332979914_01_a?wid=800&hei=800&bgColor=0,0,0,0&fmt=png-alpha&resMode=sharp2&op_sharpen=1",
      "https://fgl.scene7.com/is/image/FGLSportsLtd/FGL_332654173_01_a-Nike-Mens-Flex-Control-3-Training-Shoes-Black-Anthracite-AJ5911-002?wid=800&hei=800&bgColor=0,0,0,0&fmt=png-alpha&resMode=sharp2&op_sharpen=1",
      "https://fgl.scene7.com/is/image/FGLSportsLtd/FGL_332762662_10_a-Nike-Womens-Air-Precision-II-Basketball-Shoes-White-Black-AA7069-100?bgColor=0,0,0,0&fmt=png-alpha&hei=528&resMode=sharp&qlt=85,1&op_sharpen=1",
    ],
    brand: "Nike",
    price: 200,
    quantity: 1,
    tags: ["shoe", "shoes", "nike", "airmax", "air"],
    hasSize: true,
    sizes: [41, 42, 43, 44],
  },
  {
    id: 2,
    title: "B.Hydra",
    images: [
      "https://cdn.shopify.com/s/files/1/1922/2013/products/Littles_desktop_resize_0006_B-HydraGEL_1024x1024_f4f74c5d-372a-404f-8be1-6b8bfce12363_480x480.png?v=1586574224",
      "https://cdn.shopify.com/s/files/1/1922/2013/products/Littles_desktop_resize_0006_B-HydraGEL_1024x1024_f4f74c5d-372a-404f-8be1-6b8bfce12363_480x480.png?v=1586574224",
      "https://cdn.shopify.com/s/files/1/1922/2013/products/Littles_desktop_resize_0006_B-HydraGEL_1024x1024_f4f74c5d-372a-404f-8be1-6b8bfce12363_480x480.png?v=1586574224",
    ],
    brand: "DE",
    price: 48,
    quantity: 1,
    tags: ["serum", "hudration"],
    hasSize: false,
    description: " Intensive Hydration Serum",
  },
  {
    id: 3,
    title: "Mat",
    images: [
      "https://fgl.scene7.com/is/image/FGLSportsLtd/FGL_333205820_99_a-Gaiam-6mm-Printed-Yoga-Mat-06-63961?wid=800&hei=800&bgColor=0,0,0,0&fmt=png-alpha&resMode=sharp2&op_sharpen=1",
      "https://fgl.scene7.com/is/image/FGLSportsLtd/FGL_333205818_99_d?wid=800&hei=800&bgColor=0,0,0,0&fmt=png-alpha&resMode=sharp2&op_sharpen=1",
      "https://www.stadium.fi/INTERSHOP/static/WFS/Stadium-FinlandB2C-Site/-/Stadium/fi_FI/Small1x1/304052_101_GAIAM_YOGA%20MAT%20BRONZE%20MEDAL%206MM.png      ",
    ],
    brand: "Gaiam",
    price: 30,
    quantity: 1,
    tags: ["yoga", "mat"],
    description: "Yoga Mat 6mm",
  },
  {
    id: 4,
    title: "Proten",
    images: [
      "https://olimpsport.com/pub/media/catalog/product/optimized/9/6/96554e8998c0398043e070ca3c9b347da92ffa4308d8d4c6eb1ef383ccbc336c/whey_protein_complex_sleeve_doublechocolate_render0000_1.png",
      "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1546524478-029324_A.png",
      "https://www.nutritechfit.com/wp-content/uploads/2018/04/Nutritech-premium-whey-protein-2kg-choc-thumbnail.png",
    ],
    brand: "WHEY",
    price: 90,
    quantity: 1,
    tags: ["sport", "proten", "whey", "fitness"],
    description: "Whey proten 1800g",
  },
  {
    id: 5,
    title: "Eyewear",
    images: [
      "https://phoneticeyewear.com/var/images/product_variant/1024.768/2007_antique_tort.png",
      "https://www.bio-energy.ch/wp-content/uploads/2019/11/anti-blue-light-blue-blocking-glasses-tortoise-model-1000x500-500x250.png",
      "https://cdn.shopify.com/s/files/1/0896/5742/products/BL001_MG12_300x.png?v=1572571298",
    ],
    brand: "Phonetic",
    price: 70,
    quantity: 1,
    tags: ["eyewear", "glasses", "bluelight"],
    description: "Miller Blue Light Glasses",
  },
  {
    id: 6,
    title: "Hair care",
    images: [
      "https://www.yvesrocher.ca/medias/?context=bWFzdGVyfGltYWdlc3w0Mjg4NzB8aW1hZ2UvcG5nfHN5c19tYXN0ZXIvaW1hZ2VzL2g3OC9oOWMvODkyMjE5OTEzMDE0MnxmNTBmN2NiYmM0YzlmMmI0YTM3YmI0NjAyZjFmMTQ5YjExZDNiMDRmYjY1M2M5MDNkMzRkNDBjNTlkOGQ2YjVj&width=590&height=590",
      "https://www.yvesrocher.ca/medias/?context=bWFzdGVyfGltYWdlc3w0Mjg4NzB8aW1hZ2UvcG5nfHN5c19tYXN0ZXIvaW1hZ2VzL2g3OC9oOWMvODkyMjE5OTEzMDE0MnxmNTBmN2NiYmM0YzlmMmI0YTM3YmI0NjAyZjFmMTQ5YjExZDNiMDRmYjY1M2M5MDNkMzRkNDBjNTlkOGQ2YjVj&width=590&height=590",
      "https://www.yvesrocher.ca/medias/?context=bWFzdGVyfGltYWdlc3w0Mjg4NzB8aW1hZ2UvcG5nfHN5c19tYXN0ZXIvaW1hZ2VzL2g3OC9oOWMvODkyMjE5OTEzMDE0MnxmNTBmN2NiYmM0YzlmMmI0YTM3YmI0NjAyZjFmMTQ5YjExZDNiMDRmYjY1M2M5MDNkMzRkNDBjNTlkOGQ2YjVj&width=590&height=590",
    ],
    brand: "yvesrocher",
    price: 10,
    quantity: 1,
    tags: ["hair", "hair mask", "personal care", "cream"],
    description: "Repair - Mini 2 in 1 Balm Hair Mask",
  },
];
